// extracted by mini-css-extract-plugin
module.exports = {"container":"Import_container__vZPrN","tableWrapper":"Import_tableWrapper__XSY4l","table":"Import_table__2Ao0K","paragraph":"Import_paragraph__S1GwP"};